import { defineSlotRecipe } from '@chakra-ui/react'
import { listAnatomy } from '@chakra-ui/react/anatomy'

export const listSlotRecipe = defineSlotRecipe({
    slots: listAnatomy.keys(),
    variants: {
        variant: {
            marker: {
                item: {
                    _marker: {
                        color: 'fg',
                    },
                },
                root: {
                    '&:is(ul)': {
                        listStyleType: 'disc',
                    },
                },
            },
            gigi: {
                item: {
                    _light: {
                        _hover: {
                            bgColor: 'gray.50',
                        },
                        '&.active': {
                            bgColor: 'gray.50',
                        },
                    },
                    _dark: {
                        _hover: {
                            bgColor: 'rgba(255, 255,255, 0.08)',
                        },
                        '&.active': {
                            bgColor: 'rgba(255, 255,255, 0.08)',
                        },
                    },
                },
            },
        },
    },
})
